import {
    isRightDrawerMemberNotShiftedIn,
    isRightDrawerMemberShiftedOut,
} from "../Common/Composables/useRightDrawerMemberShiftUi.js";

export const LIVE_SCREENSHOTS_ACTIVE_YES = "yes";
export const LIVE_SCREENSHOTS_ACTIVE_NO = "no";

export const LIVE_SCREENSHOTS_ACTIVE_DEFAULT = LIVE_SCREENSHOTS_ACTIVE_YES;

/**
 * @param {string|null|undefined} value
 * @returns {typeof LIVE_SCREENSHOTS_ACTIVE_YES | typeof LIVE_SCREENSHOTS_ACTIVE_NO}
 */
export function resolveLiveScreenshotsActiveFilter(value) {
    return value === LIVE_SCREENSHOTS_ACTIVE_NO
        ? LIVE_SCREENSHOTS_ACTIVE_NO
        : LIVE_SCREENSHOTS_ACTIVE_YES;
}

export const LIVE_SCREENSHOTS_ACTIVE_OPTIONS = [
    { label: "Yes", value: LIVE_SCREENSHOTS_ACTIVE_YES },
    { label: "No", value: LIVE_SCREENSHOTS_ACTIVE_NO },
];

/**
 * @param {{ usr_profile_logged_time_fetched?: boolean }|null|undefined} appState
 * @returns {boolean}
 * @deprecated Team dashboard live screenshots use API shift fields; prefer {@link areTeamDashboardShiftStatesReady}.
 */
export function areLiveScreenshotWorklogsReady(appState) {
    return Boolean(appState?.usr_profile_logged_time_fetched);
}

/**
 * Active Yes: currently shifted in or shift paused.
 * Active No: yet to shift in or already shifted out.
 *
 * @param {{ shift_status?: unknown, recent_shift_event_at?: unknown }|null|undefined} member
 * @param {{ isShiftNotShiftedIn?: (status: unknown) => boolean, isShiftOut: (status: unknown) => boolean }} timeTracker
 * @returns {boolean}
 */
export function isLiveScreenshotAssociateActive(member, timeTracker) {
    if (!member) {
        return false;
    }

    if (isRightDrawerMemberNotShiftedIn(member, timeTracker)) {
        return false;
    }

    if (isRightDrawerMemberShiftedOut(member, timeTracker)) {
        return false;
    }

    return true;
}

/**
 * Filter live screenshot cards by Active Yes/No.
 *
 * @param {Array<{ user_profile_id?: string|number }>} screenshots
 * @param {string} activeFilter - {@link LIVE_SCREENSHOTS_ACTIVE_YES} | {@link LIVE_SCREENSHOTS_ACTIVE_NO}
 * @param {(userProfileId: string|number|null|undefined) => boolean} isAssociateActive
 * @param {boolean} [worklogsReady=true] - false while shift-timer rows have not arrived
 * @returns {Array}
 */
export function filterLiveScreenshotsByActive(
    screenshots,
    activeFilter,
    isAssociateActive,
    worklogsReady = true,
) {
    const list = Array.isArray(screenshots) ? screenshots : [];

    if (!worklogsReady) {
        return list;
    }

    const want_active = activeFilter !== LIVE_SCREENSHOTS_ACTIVE_NO;

    return list.filter((screenshot) => {
        const is_active = Boolean(
            isAssociateActive?.(screenshot?.user_profile_id),
        );

        return want_active ? is_active : !is_active;
    });
}
